// extracted by mini-css-extract-plugin
export default {"doc-page-wrapper":"p_9 container-lg d-flex p-3","doc-page":"p_bb","doc-page__title--enterprise":"p_bc","doc-page--with-side-menu":"p_bd","doc-page__title":"p_bf"};